import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Styling from 'components/AuthStyling';
import * as Yup from 'yup';
import Input, { STYLE_TYPE } from 'components/Forms/Fields/TextInput';
import { Formik } from 'formik';
import API from 'services/api';
import Button from 'components/Button';
import styles from './index.module.scss';
import { updateURLQueryString } from 'sagas/user/help';

const RecoverPassword = ({ history }) => {
  const [user, setUser] = useState({ email: '' });

  async function recoverPassword() {
    API.recoverPassword(user)
      .then(() => {
        history.push({
          pathname: '/pwd-recover/success',
          state: { email: user.email },
        });
        updateURLQueryString('/pwd-recover/success');
      })
      .catch(error => {
        console.log(error);
      });
  }

  const setEmail = e => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    setUser({ ...user, [fieldName]: fieldValue });
  };

  const recover = e => {
    e.preventDefault();
    recoverPassword();
  };

  const cancel = () => {
    history.push('/login');
  };

  const FORM_VALIDATION = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .max(320, 'Must be 320 characters or less')
      .required('Email is required'),
  });

  return (
    <Styling message="Please enter your email so that we send you a reset password link.">
      <Formik initialValues={{ ...user }} validationSchema={FORM_VALIDATION}>
        {({ values, errors, dirty, handleChange }) => {
          return (
            <form className={styles.formContent} noValidate onSubmit={recover}>
              <div className={styles.formArea}>
                <Input
                  id="recover-email"
                  className={styles.blackText}
                  field="email"
                  value={values.email}
                  fullWidth
                  placeholder="Email"
                  margin="normal"
                  error={errors.email}
                  onChange={e => {
                    handleChange(e);
                    setEmail(e);
                  }}
                  styleType={STYLE_TYPE.loginInput}
                />
              </div>

              <div className={styles.buttonRow}>
                <Button
                  type="button"
                  onClick={cancel}
                  text="Cancel"
                  color="secondary"
                  theme="light"
                />
                <Button
                  type="submit"
                  text="Request"
                  disabled={!dirty || errors.email}
                  onClick={recover}
                />
              </div>
            </form>
          );
        }}
      </Formik>
    </Styling>
  );
};

RecoverPassword.propTypes = {
  history: PropTypes.object.isRequired,
};

export default RecoverPassword;
